import { render, staticRenderFns } from "./dyd1920.vue?vue&type=template&id=3412ec69&scoped=true&"
import script from "./dyd1920.vue?vue&type=script&lang=js&"
export * from "./dyd1920.vue?vue&type=script&lang=js&"
import style0 from "./dyd1920.vue?vue&type=style&index=0&id=3412ec69&lang=less&scoped=true&"
import style1 from "./dyd1920.vue?vue&type=style&index=1&id=3412ec69&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3412ec69",
  null
  
)

export default component.exports